import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },

  menuOption: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: '1.5rem 0',

    '& label': {
      cursor: 'pointer',
      userSelect: 'none'
    }
  },

  marginTop: {
    marginTop: '1.5rem'
  },

  avatar: {
    width: 24,
    height: 24,
    marginRight: '0.5rem',
    fontSize: theme.size.sm
  },

  selected: {
    color: theme.palette.primary.main,
    fontSize: theme.size.base
  },

  rectangle: {
    width: 5,
    height: 18,
    marginRight: '0.5rem',

    background: theme.palette.primary.main,
    borderRadius: '0px 8px 8px 0px',
    transform: 'matrix(1, 0, 0, -1, 0, 0)'
  },

  count: {
    marginLeft: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100rem',
    height: '18px',
    padding: '0 5px',
    background: '#B64FCD',
    fontSize: theme.size.sm,
    color: 'white'
  },

  pushLeft: {
    marginLeft: '0.5rem'
  }
}))

export default useStyles
